export const subtitles = {
    "1": {
        "startTime": 0.74,
        "endTime": 6.69,
        "transcript": "Qanruyutnek iciw' makunun ayagyuanun maa-i-rpak.",
        "translation": "Traditional wisdom, you know, for the young people today."
    },
    "2": {
        "startTime": 6.69,
        "endTime": 13.02,
        "transcript": "Iciw' piciatun camek qalarcullranek apqaurluku piyuk'ngaanek.",
        "translation": "You know, ask him about whatever he wants to talk about."
    },
    "3": {
        "startTime": 13.02,
        "endTime": 16.02,
        "transcript": "Iciw' inerqualuki wall' canek.",
        "translation": "You know, admonishing them or something."
    },
    "4": {
        "startTime": 17.215,
        "endTime": 19.525,
        "transcript": "Nutaan ayagnirluten.",
        "translation": "Please start now."
    },
    "5": {
        "startTime": 20.825,
        "endTime": 22.615,
        "transcript": "Nutaan-qaa tua wanigga?",
        "translation": "Is it time now?"
    },
    "6": {
        "startTime": 23.043,
        "endTime": 30.334,
        "transcript": "Watua maa-i ayagyugaat makut wii wangkuta ayagyugaullerput civuqlia",
        "translation": "Now, these young people, before, when we were young"
    },
    "7": {
        "startTime": 30.549,
        "endTime": 38.603,
        "transcript": "Civuqliani watua maa-i makut kinguqliput wangkuta ayagyugaullerput uniurteqapiggluku pilriit.",
        "translation": "Our descendants now have completely left what we were like when we were young in the past."
    },
    "8": {
        "startTime": 38.837,
        "endTime": 42.525,
        "transcript": "Camek enuqitenritellrata arcaqaqai.",
        "translation": "What makes it worse is that they do not lack anything."
    },
    "9": {
        "startTime": 42.525,
        "endTime": 47.77,
        "transcript": "Wangkuta ayagyugaullemteńi ca tamalkuan nuuqluku pillruamteggu.",
        "translation": "Because when we were young, everything was scarce for us."
    },
    "10": {
        "startTime": 48.033,
        "endTime": 52.642,
        "transcript": "Aturat, neqkat-llu tamalkuita, cat tamalkuita nuuqluki.",
        "translation": "Clothes, and all food, everything was scarce for us."
    },
    "11": {
        "startTime": 52.852,
        "endTime": 60.443,
        "transcript": "Tau͡gken-am maa-i mat'um nalliini makut tan'gurraat kinguqliput ca tamalkuan nallulriatun ayuqluku.",
        "translation": "However, it's like the boys of the next generations these days do not know anything."
    },
    "12": {
        "startTime": 60.448,
        "endTime": 64.939,
        "transcript": "Makut civuqliit pingnatullrat nalluku",
        "translation": "They don't know how these ancestors worked hard to survive"
    },
    "13": {
        "startTime": 65.604,
        "endTime": 72.949,
        "transcript": "Ca tamalkuan piyukengarteng tamalkuan aturyuk'ngarteng tegutauluku pillruameng, pingengameng.",
        "translation": "Because they can easily take anything they want or need."
    },
    "14": {
        "startTime": 72.963,
        "endTime": 81.181,
        "transcript": "Wangkuta-am maa-i civuqliani qayatgurrlainaq tau͡gaam pitullrulriakut anguarturluta.",
        "translation": "In the past, we only used kayaks and rowed all the time."
    },
    "15": {
        "startTime": 81.568,
        "endTime": 86.286,
        "transcript": "Massiinamek ataucirquungraan tangyuitellruunga wii tamaani.",
        "translation": "I never saw a boat motor once back then."
    },
    "16": {
        "startTime": 86.503,
        "endTime": 88.948,
        "transcript": "Enengqerrluta-llu mud house.",
        "translation": "And we had a [traditional] mud house."
    },
    "17": {
        "startTime": 89.333,
        "endTime": 95.088,
        "transcript": "Kass'ameng-ll' ataucirquungraan tangyuuni. Kass'at nurqapiggluta.",
        "translation": "And I never saw a Caucasian even once. Caucasians didn't come anywhere near us."
    },
    "18": {
        "startTime": 95.923,
        "endTime": 104.33,
        "transcript": "Tau͡gken-am maa-i mat'um nalliini Kass'at amlleriata makut-ll' ayagyugaat tan'gurraat qaillun ayuqliriluteng.",
        "translation": "Now, however, since there are now a lot of Caucasians, these young boys have become different."
    },
    "19": {
        "startTime": 104.724,
        "endTime": 111.688,
        "transcript": "Mat'umek arcaqerluki merkam piyukai. Uyviirutellriatun ayuqekai merkam.",
        "translation": "Alcohol especially affects them. Alcohol makes them act crazy."
    },
    "20": {
        "startTime": 112.463,
        "endTime": 122.463,
        "transcript": "Umyugaqa iliini navguraqaat tau͡gaten pissiyaagpakaraqata man'a erneqegtaar Agayutem cikiutii iqlukun aturpakaraqatku.",
        "translation": "Sometimes, they make me very despondent when they do that too much, using the wonderful days that are God's gifts the wrong way."
    },
    "21": {
        "startTime": 122.596,
        "endTime": 126.56,
        "transcript": "Qaneqsaunii umyugaqa tua-i navguraquq taumeng.",
        "translation": "Without saying anything, that makes me very despondent."
    },
    "22": {
        "startTime": 126.657,
        "endTime": 131.229,
        "transcript": "Also, when they blaspheme against our lord",
        "translation": "Also, when they blaspheme against our lord"
    },
    "23": {
        "startTime": 131.463,
        "endTime": 138.363,
        "transcript": "Wanigga ellaitngulriani iliini umyugaqa qanernaqsaaquq waten umyugarturluni:",
        "translation": "For them, sometimes, my mind wants to say something thinking like this:"
    },
    "24": {
        "startTime": 138.456,
        "endTime": 144.956,
        "transcript": "\"Wangkutneng taqellrunritukut. Agayutem piliaqelqaakut. Tauna pinrilengramku canrituq.\"",
        "translation": "\"We didn't create ourselves. God made us. It's okay if I don't say anything to him.\""
    },
    "25": {
        "startTime": 144.97,
        "endTime": 149.497,
        "transcript": "Atam Agayun pilillruun elliin yugkaminek pikaminek.",
        "translation": "You see, God made people for himself."
    },
    "26": {
        "startTime": 150.301,
        "endTime": 152.983,
        "transcript": "Tau͡gaam avvluteng maa-i.",
        "translation": "But they are divided now."
    },
    "27": {
        "startTime": 153.297,
        "endTime": 160.715,
        "transcript": "Kitaki-tuq maa-i-tuq uum kinguakun-tuq wanigga tan'gurraat makut iliit umyugangarteqerli",
        "translation": "So, I hope that today, after this, one of these boys will come to a realization"
    },
    "28": {
        "startTime": 161.001,
        "endTime": 166.837,
        "transcript": "Umyugangluni piqerli tamatumeng pitsaqevkenani iqlutun atussiyaagpakallerkamineng.",
        "translation": "May he come to a realization in case he is doing that the wrong way too much."
    },
    "29": {
        "startTime": 168.503,
        "endTime": 174.375,
        "transcript": "Wanigga wangkuta maa-i, maa-i ak'anurpak anerteqngairutellriakut.",
        "translation": "Now, we will not live for too much longer."
    },
    "30": {
        "startTime": 174.39,
        "endTime": 180.835,
        "transcript": "Wii-llu al'rrakut amlleret tegulua. Ak'a nallunarinayuklua umyugarteqellruyaaqua.",
        "translation": "I have also taken upon many years. I had thought that I would have been gone already."
    },
    "31": {
        "startTime": 180.839,
        "endTime": 185.467,
        "transcript": "Tau͡gaam maa-i quyanarquq Agayun una tekilluku anerteqevkarlua.",
        "translation": "But I am thankful to God that he has allowed me to live this long."
    },
    "32": {
        "startTime": 185.638,
        "endTime": 194.401,
        "transcript": "Kesiin ukisqaqluku piuraqunegteggu makut tan'gurraat aipaqureluku ayallermeng tamalkuan",
        "translation": "If these boys always turn to him for help and go with him throughout all of their life"
    },
    "33": {
        "startTime": 194.868,
        "endTime": 200.14,
        "transcript": "Callra tamalkurmi iliini cikiraqluki kaigatiitnek piyarai.",
        "translation": "With everything he does, he may sometimes be given what he asks for."
    },
    "34": {
        "startTime": 200.809,
        "endTime": 210.618,
        "transcript": "Wanigga tan'gu'rrni elpeci, tan'gu'rrni tamalkurpeci niitellriani, niicugnilriani una tau͡ga umyugaqeqerniararci:",
        "translation": "You boys here, all of you boys here who are listening, remember this:"
    },
    "35": {
        "startTime": 210.941,
        "endTime": 217.704,
        "transcript": "Elpeneng yuurtellrunrituten. Agayutem tau͡gaam caliaqelqaaten, yuurcitelqaaten.",
        "translation": "You were not born of yourself. However, God worked on you and made you to be born."
    },
    "36": {
        "startTime": 217.952,
        "endTime": 220.498,
        "transcript": "Ellii yuknaluten.",
        "translation": "So that you would be his child."
    },
    "37": {
        "startTime": 220.7,
        "endTime": 228.282,
        "transcript": "Tau͡gken elpeneng maa-i ayatmun pilriaten. Cali elpeneng picurlatmun piyaqelriaten.",
        "translation": "However, you are not going by yourself. Also, you bring yourself to misfortune."
    },
    "38": {
        "startTime": 230.422,
        "endTime": 235.95,
        "transcript": "Kia yuum ukisqiangaitaaten maa-i yuungnaqlerpeni elliin avatiikun.",
        "translation": "No person will help you as you try to live here aside from him."
    },
    "39": {
        "startTime": 235.961,
        "endTime": 242.024,
        "transcript": "Agayutem tau͡gaam ukisqiumaciqaaten kaigakuvet tan'gu'rrni elpeci.",
        "translation": "Only God will help you if you boys ask of it."
    },
    "40": {
        "startTime": 242.101,
        "endTime": 248.019,
        "transcript": "Maa-i niicugnilriani tamalkurpeci, qanrutnaumci. Niiskicia.",
        "translation": "All of you who are listening now, let me tell you. Hear me."
    },
    "41": {
        "startTime": 248.032,
        "endTime": 255.404,
        "transcript": "Imumi makuneng pingvailemta yuut assiq'apiarallruut tamalkurmeng.",
        "translation": "A long time ago, before we had this these, every single person was extremely good."
    },
    "42": {
        "startTime": 256.612,
        "endTime": 265.385,
        "transcript": "Cameng-gga tua-i qiruanarqelriameng, imkucilriameng-gga paqricilriameng-llu niitnaunateng.",
        "translation": "We didn't hear about anything that made us [?sad], well, and people going missing."
    },
    "43": {
        "startTime": 265.678,
        "endTime": 275.478,
        "transcript": "Maa-i tau͡gken nalluvcini maa-i tan'gurraat makut niicugnilriani, ca tamalkurmi piciqaangainariluni.",
        "translation": "Now, however, for you boys who are listening, everything has become commonplace."
    },
    "44": {
        "startTime": 276.493,
        "endTime": 283.693,
        "transcript": "Ca tamak'acagarmi piciqaangaanariluni, ca-ll' niicurlakallerkaa cailkamun pinariluni.",
        "translation": "Every single things has become commonplace, including hearing bad news about something at random."
    },
    "45": {
        "startTime": 283.707,
        "endTime": 286.888,
        "transcript": "Elliqalriani ak'a-llu tayim' cataunani.",
        "translation": "When something is put, it's already gone [stolen]."
    },
    "46": {
        "startTime": 287.054,
        "endTime": 293.227,
        "transcript": "Tamana umyugaqekuvcu Agayutem piliaqellra tamakut ilangciyuunaki yuuyartuten.",
        "translation": "If you remember that God made them, you would live life without paying them any mind."
    },
    "47": {
        "startTime": 293.42,
        "endTime": 299.484,
        "transcript": "Kitak' wanigga elluarrluten yuungnaquraqina wanigga waken ayagluteng.",
        "translation": "Now, try to live life well from this day forward."
    },
    "48": {
        "startTime": 300.06,
        "endTime": 301.569,
        "transcript": "Cali una...",
        "translation": "This too..."
    },
    "49": {
        "startTime": 304.218,
        "endTime": 305.509,
        "transcript": "Tau͡ga-qaa?",
        "translation": "Is that all?"
    },
    "50": {
        "startTime": 316.32,
        "endTime": 318.953,
        "transcript": "Cameng im' piqataryaaqellrulrianga?",
        "translation": "What was I going to say again?"
    },
    "51": {
        "startTime": 320.621,
        "endTime": 328.098,
        "transcript": "Maa-i, cali maa-i umyugartullerniaqa wii wanigg' qanrutkeqataraqa.",
        "translation": "Now, I am going to speak about what I've been thinking about lately."
    },
    "52": {
        "startTime": 328.486,
        "endTime": 337.098,
        "transcript": "Maa-i takaitqapigtellriakut wangkuta taqestemteńun, Agayutmun taqestemteńun.",
        "translation": "Now, we have absolutely no respect to our creator, God our creator."
    },
    "53": {
        "startTime": 337.264,
        "endTime": 344.419,
        "transcript": "Una anllitellra Christmas-aaq, Quyavik-llu Thanksgiving-aq",
        "translation": "His nativity, Christmas, and Quyavik, Thanksgiving"
    },
    "54": {
        "startTime": 344.647,
        "endTime": 350.703,
        "transcript": "Iqlutun upyutaqekci. Tan'gu'rrni elpeci niicugnilriani, maa-i niicugnici.",
        "translation": "You prepare for them the wrong way. You boys who are listening, listen now."
    },
    "55": {
        "startTime": 350.715,
        "endTime": 354.193,
        "transcript": "Iqlutun upyutaqekci, iqluggun.",
        "translation": "You prepare for them the wrong way, the wrong way."
    },
    "56": {
        "startTime": 354.201,
        "endTime": 360.101,
        "transcript": "Upyutarkarci tau͡gken qamna ircaqurci uptarkarci Agayutmun uptevkenaku.",
        "translation": "Yet what you are supposed to prepare, your heart inside, you do not prepare for God."
    },
    "57": {
        "startTime": 360.369,
        "endTime": 368.358,
        "transcript": "Kitak' wanigga uum kinguakun eneqakluku iqluggun uptessiyaallerkarci pingniarci.",
        "translation": "So after this, remember [not to] prepare the wrong way."
    },
    "58": {
        "startTime": 368.369,
        "endTime": 370.913,
        "transcript": "Atam allamek uqisqirtekaitukut.",
        "translation": "You see, we have no other help."
    },
    "59": {
        "startTime": 371.271,
        "endTime": 383.404,
        "transcript": "Cali wanigga ikayuryuumiryaaqngamci maa-i iqlutmun-llu umyugarci umyugiryuumiryaaqngamci. Wii Agayutngunrilama tau͡gaam umyugirciigatamci.",
        "translation": "Since I also want to help you now, and I want to make you repent from the wrong ways of your mind. But since I'm not God, I can't make you repent."
    },
    "60": {
        "startTime": 383.42,
        "endTime": 392.075,
        "transcript": "Tau͡gaam elpecineng tukautengnaqerkauguci. Maa-i yuucirci tukautengnaqerkaugarci maa-i elpecineng tau͡gaam. Kia ukisqiangaitaaci.",
        "translation": "But you must kick yourselves off. You must kick your lives off, but only by yourselves. No one will help you."
    },
    "61": {
        "startTime": 392.397,
        "endTime": 395.241,
        "transcript": "Elliin kiimi ukisqiaciqaaci.",
        "translation": "Only he will help you."
    },
    "62": {
        "startTime": 395.25,
        "endTime": 404.695,
        "transcript": "Wanigga-am ukut quyanarqeqapigtellriit naken amaken yaaqvaneng tailuteng qanercillua wanigg' qaneryugnaitellemneng, qaneryuumillernaamneng.",
        "translation": "Now, I am very thankful to these people who came from somewhere far away and had me speak about what I wouldn't have spoken about, what I've been wanting to speak about."
    },
    "63": {
        "startTime": 404.7,
        "endTime": 411.3,
        "transcript": "Yaani-llu KYUK-mi iliini tekiartaqama qaneryuumiryaaqaqua.",
        "translation": "And sometimes, when I come across KYUK over there, I want to speak."
    },
    "64": {
        "startTime": 411.318,
        "endTime": 417.963,
        "transcript": "Qanqeryuumiryaaqaqua mat'umeng waten tan'gurraat iliit cellangarteqernayukluku.",
        "translation": "I have been wanting to say this in case one of the boys might come to a realization."
    },
    "65": {
        "startTime": 418.479,
        "endTime": 424.935,
        "transcript": "Kitak' wanigga tau͡gaten tamana qanelqa niilluku niicugnilriani tamalkurpeci.",
        "translation": "Now, hear what I said, all of you who are listening."
    },
    "66": {
        "startTime": 424.947,
        "endTime": 435.936,
        "transcript": "Au͡gaqliten-llu au͡gani qang'a-llu maani wani Naparyarmiuni wanigga-tuq maa-i iliit yuut atauciunge'rmi umyugaa qanqerli tamatumeng.",
        "translation": "And the people aroung you, and even here in Hooper Bay, I hope that some people, even just one, will say that in their mind."
    },
    "67": {
        "startTime": 435.945,
        "endTime": 441.723,
        "transcript": "Arcaqerluku man'a yuucim iqungutkekii aturyuk'ngarci man'a",
        "translation": "Especially this thing that makes life end badly that you keep using"
    },
    "68": {
        "startTime": 441.993,
        "endTime": 450.504,
        "transcript": "Alarqutngukan, alarqutngukan man'a taangaq aturyuk'ngarci kituunge'rmi atuyuicaraa.",
        "translation": "If this alcohol that you keep using were a traditional instruction, no one would use it."
    },
    "69": {
        "startTime": 450.521,
        "endTime": 454.265,
        "transcript": "Alarquutngunrilan maa-i inerquutaungan aturyugaqaa.",
        "translation": "You keep using it because it's not traditional instruction, but an admonishment."
    },
    "70": {
        "startTime": 454.269,
        "endTime": 460.069,
        "transcript": "Alarquutet tau͡gken aturyuyuunaki, aturyugluki, aturyugpegnaki.",
        "translation": "Yet you do not follow the traditional instructions."
    },
    "71": {
        "startTime": 460.642,
        "endTime": 469.531,
        "transcript": "Alarquutngunrilnguut tau͡gken piluki-gga ayimumalriatun piluki, ayimumatekluki.",
        "translation": "Yet they are broken [from doing] what are not traditional instructions."
    },
    "72": {
        "startTime": 469.536,
        "endTime": 474.981,
        "transcript": "Tau͡gaam tau͡ga-i quyanarquq tau͡ga qanqertua amllenrilengraan. Quyana cakneq.",
        "translation": "But I am thankful that I have spoken even though it wasn't a lot. Thank you very much."
    },
    "73": {
        "startTime": 474.992,
        "endTime": 477.581,
        "transcript": "Piuraqici tau͡ga erneqegcikici tau͡gaam.",
        "translation": "Goodbye and have a good day."
    },
    "74": {
        "startTime": 477.595,
        "endTime": 478.584,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "75": {
        "startTime": 482.428,
        "endTime": 484.406,
        "transcript": "Yugtun-mi kituusit?",
        "translation": "Who are you in Yup'ik?"
    },
    "76": {
        "startTime": 484.416,
        "endTime": 485.649,
        "transcript": "Cimiciaq.",
        "translation": "Cimiciaq"
    },
    "77": {
        "startTime": 485.658,
        "endTime": 487.336,
        "transcript": "(Kina?) Cimiciaq.",
        "translation": "(Who?) Cimiciaq."
    },
    "78": {
        "startTime": 487.35,
        "endTime": 491.039,
        "transcript": "\"Jimmy-and-Jack,\" Cimiciaq.",
        "translation": "\"Jimmy-and-Jack,\" Cimiciaq."
    },
    "79": {
        "startTime": 494.391,
        "endTime": 495.969,
        "transcript": "Cimiciaq.",
        "translation": "Cimiciaq."
    },
    "80": {
        "startTime": 497.486,
        "endTime": 498.819,
        "transcript": "Cimiciaq.",
        "translation": "Cimiciaq."
    },
    "81": {
        "startTime": 500.97,
        "endTime": 505.637,
        "transcript": "It's like a Kass'aq's names, \"Jimmy-and-Jack.\"",
        "translation": "It's like English names, \"Jimmy-and-Jack.\""
    },
    "82": {
        "startTime": 506.855,
        "endTime": 508.611,
        "transcript": "Cimiciaq.",
        "translation": "Cimiciaq."
    },
    "83": {
        "startTime": 509.531,
        "endTime": 511.231,
        "transcript": "Qavcircit?",
        "translation": "How old are you?"
    },
    "84": {
        "startTime": 511.235,
        "endTime": 518.279,
        "transcript": "Seventy-six years old. Seven-eight-arniarartua. Seventy-six years old.",
        "translation": "Seventy-six years old. I'm almost 78. Seventy-six years old."
    },
    "85": {
        "startTime": 523.293,
        "endTime": 525.737,
        "transcript": "Without gray hair.",
        "translation": "Without gray hair."
    },
    "86": {
        "startTime": 528.124,
        "endTime": 530.18,
        "transcript": "Uingqertuten?",
        "translation": "Do you have a husband?"
    },
    "87": {
        "startTime": 530.195,
        "endTime": 534.095,
        "transcript": "No. (Piunrillruuq?) Piunrillruut.",
        "translation": "No. (Did he pass away?) They passed away."
    },
    "88": {
        "startTime": 535.943,
        "endTime": 538.42,
        "transcript": "Long ago, long ago.",
        "translation": "Long ago, long ago."
    },
    "89": {
        "startTime": 539.425,
        "endTime": 541.77,
        "transcript": "Irniaten-mi qavciugaq?",
        "translation": "How many children do you have?"
    },
    "90": {
        "startTime": 541.786,
        "endTime": 543.93,
        "transcript": "Cetamaugut.",
        "translation": "There are four of them."
    },
    "91": {
        "startTime": 544.48,
        "endTime": 546.247,
        "transcript": "Quyurmeng-mi?",
        "translation": "What about altogether?"
    },
    "92": {
        "startTime": 547.484,
        "endTime": 551.084,
        "transcript": "Quyurmeng au͡gkut-llu piunrillret...",
        "translation": "Altogether, including the ones who passed away..."
    },
    "93": {
        "startTime": 551.093,
        "endTime": 559.415,
        "transcript": "...and Nathan have a [?fisher's]...",
        "translation": "...and Nathan have a [?fisher's]..."
    },
    "94": {
        "startTime": 561.524,
        "endTime": 571.524,
        "transcript": "Makut maa-i, makut maa-i medicine-aqlernaaput civuliamteńeng ayagluteng caqlat.",
        "translation": "These are the medicine that we've always had starting from our ancestors, rosewort roots."
    },
    "95": {
        "startTime": 572.04,
        "endTime": 577.773,
        "transcript": "Waten acilqurrit, makut acilqurrit caqlat",
        "translation": "The roots like this, these rosewort roots"
    },
    "96": {
        "startTime": 577.78,
        "endTime": 582.713,
        "transcript": "Civuliaqellernaaput amiirluki, amiirluki",
        "translation": "Our ancestors of old would peel them, peel them"
    },
    "97": {
        "startTime": 582.731,
        "endTime": 592.687,
        "transcript": "Akaangsaaraq sore mouth-araqata mikelngumeggnun tamuaqerluki waten piaqluki.",
        "translation": "A long time ago, when their children had sore throats, they would chew then then do this."
    },
    "98": {
        "startTime": 593.004,
        "endTime": 595.393,
        "transcript": "Uryuutaqluki.",
        "translation": "They [?] for them."
    },
    "99": {
        "startTime": 595.762,
        "endTime": 604.518,
        "transcript": "Tau͡ga-i-llu cali caaqameng, sore-ameggnun-llu piaqluki.",
        "translation": "Then when thye had other ailments, they would also put them on their sores."
    },
    "100": {
        "startTime": 604.747,
        "endTime": 610.758,
        "transcript": "Ikayuutekluki makut amiiqerraarluki tau͡gaam, amiit au͡g'arluki.",
        "translation": "It helped them, but after they peeled, removing their outer layers."
    },
    "101": {
        "startTime": 610.948,
        "endTime": 619.148,
        "transcript": "Iliini-llu amiirluki egatmun ekluki qallarvaulluki",
        "translation": "And sometimes, they would peel them, put them into a pot, and boil them"
    },
    "102": {
        "startTime": 619.654,
        "endTime": 626.632,
        "transcript": "Cali maavet minguutekluki callartaqameng, maavet-llu.",
        "translation": "They would also apply it here when they had sores or rashes, and here too."
    },
    "103": {
        "startTime": 626.639,
        "endTime": 630.728,
        "transcript": "Naugga-m ointment-atun ayuqluteng.",
        "translation": "You know, it was like an ointment."
    },
    "104": {
        "startTime": 630.88,
        "endTime": 641.602,
        "transcript": "Tau͡ga-i-llu aturaqait makut ak'angssaaraq, caiggluut-llu imkut cali aipait. Meqluki tau͡gaten.",
        "translation": "They used to use these a long time ago, including the other ones, wormwood. People even drank them."
    },
    "105": {
        "startTime": 642.156,
        "endTime": 644.756,
        "transcript": "Makut-llu-qaa meq'etuit?",
        "translation": "Do they also drink these?"
    },
    "106": {
        "startTime": 644.773,
        "endTime": 645.551,
        "transcript": "Caugat?",
        "translation": "What are they?"
    },
    "107": {
        "startTime": 645.562,
        "endTime": 648.807,
        "transcript": "Piugut (Caqlat?) caqlaugut.",
        "translation": "They're, you know, (Rosewort roots?) rosewort roots."
    },
    "108": {
        "startTime": 648.815,
        "endTime": 655.26,
        "transcript": "Tamaa-i makut, makuneng wii (Ii-i.) tamualuki callartaqan aturaqluki.",
        "translation": "These things (Yes.) I chew them when there are sores or rashes."
    },
    "109": {
        "startTime": 655.277,
        "endTime": 661.977,
        "transcript": "Callartaqamta assiriaqluni, igyariqaqamta-llu aturluki.",
        "translation": "When we have sores, they get better, and we use them when we have sore throats."
    },
    "110": {
        "startTime": 661.979,
        "endTime": 667.745,
        "transcript": "Mecuit tau͡gaam igmarluki, tau͡gken makut piit igevkenaki.",
        "translation": "We only swallow their liquid, but don't swallow these parts."
    },
    "111": {
        "startTime": 667.881,
        "endTime": 672.936,
        "transcript": "Iciw' watua qanrutellrukevnga callarqellruniluteng ciungani?",
        "translation": "You know you told me earlier that you had a lot of sores before?"
    },
    "112": {
        "startTime": 672.955,
        "endTime": 674.221,
        "transcript": "Ii-i.",
        "translation": "Ii-i."
    },
    "113": {
        "startTime": 674.227,
        "endTime": 675.383,
        "transcript": "Tamakucinek-qaa atullruuten?",
        "translation": "Did you use those?"
    },
    "114": {
        "startTime": 675.392,
        "endTime": 683.915,
        "transcript": "Atullruunga makuneng imumi callarterpallratni Hooper Bay-rmiut mikelngurrartuumarmeng.",
        "translation": "I used these when there was a sore outbreak in Hooper Bay including among the small children."
    },
    "115": {
        "startTime": 683.926,
        "endTime": 692.97,
        "transcript": "Atulqaqa man'a niitetuama qaillun yungcautengqesciigalan all over.",
        "translation": "I used this because I heard that there is no kind of medicine [for sores] all over."
    },
    "116": {
        "startTime": 692.987,
        "endTime": 701.276,
        "transcript": "Callanret angturriluteng-llu. Nullumni-ll' camana ircaquqa maliggluku nutngaryaurrluteng.",
        "translation": "The sores grew large. And on my bottocks, they started pulsing along with my heartbeat."
    },
    "117": {
        "startTime": 701.281,
        "endTime": 707.07,
        "transcript": "Tua-ll' umyugartunglua imkut qagkumiut qanellrat eneqakluku.",
        "translation": "Then I started thinking, remembering what the people up north said."
    },
    "118": {
        "startTime": 707.082,
        "endTime": 713.449,
        "transcript": "Imna teq'uq, Amaurrlugam teq'urra aqvaluku [?].",
        "translation": "That urine, I went to get Amaurrlugaq's urine [?]."
    },
    "119": {
        "startTime": 713.461,
        "endTime": 721.538,
        "transcript": "Pia, aqvaluku wii assigcirluku taumeng erurlua, whoo, very strong.",
        "translation": "I went to get it with a container, washed myself with that, whoo, very strong."
    },
    "120": {
        "startTime": 721.694,
        "endTime": 725.35,
        "transcript": "Kirrelvagluni-ll' qaika, sore.",
        "translation": "And my body was burning, sore."
    },
    "121": {
        "startTime": 725.366,
        "endTime": 730.366,
        "transcript": "Sore-arluni maa-i. Nulluugka-llu erurlukek cuvayaaq au͡g'arluku.",
        "translation": "It was sore here. And I washed the slime of my buttocks."
    },
    "122": {
        "startTime": 730.366,
        "endTime": 737.477,
        "transcript": "Cuvayillinilua. It's like fish-am cuvayga from the sores.",
        "translation": "I had been discharging slime. It's like fish slime from the sores."
    },
    "123": {
        "startTime": 737.483,
        "endTime": 746.972,
        "transcript": "Taqngama-llu makut boil-allrenka, boil-allrenka kuvluku tauna au͡g'arluku allameng rinse-autekluku makut.",
        "translation": "When I was done, I dumped that and replaced it with these [rosewort roots] that I'd boiled, and rinsed these [sores]."
    },
    "124": {
        "startTime": 746.977,
        "endTime": 752.044,
        "transcript": "Rinse-arlua mecuitneng. Rinse-arluku taqngama.",
        "translation": "I rined with their liquid. I rinsed when I was done."
    },
    "125": {
        "startTime": 752.053,
        "endTime": 757.575,
        "transcript": "Nutaan keyianeng nangteqluni qaika, tamalkurmi nutngalriatun ayuqluni",
        "translation": "Them my body was in suffering, and it seemed that all of it was pulsing"
    },
    "126": {
        "startTime": 757.577,
        "endTime": 763.033,
        "transcript": "Too many sores in my body, mostly in my sit.",
        "translation": "Too many sores in my body, mostly in my sit[ting area]."
    },
    "127": {
        "startTime": 763.401,
        "endTime": 769.668,
        "transcript": "Angurriluteng, nutengvagluteng from my heart, maliggluku.",
        "translation": "They grew large, and they pulsed from my heart, along with [my heartbeat]."
    },
    "128": {
        "startTime": 769.862,
        "endTime": 779.04,
        "transcript": "And next day assiriyaqliama assirilua yuryugumaluku-ll'. It's like I smell it for long time.",
        "translation": "And next day, when I finally got better, I kept breathing it in. It's like I smell it for long time."
    },
    "129": {
        "startTime": 779.045,
        "endTime": 783.457,
        "transcript": "Qanemneng aneryaamneng au͡g'asciigalnganani.",
        "translation": "It seemed it couldn't get out of my mouth, my breath."
    },
    "130": {
        "startTime": 784.247,
        "endTime": 793.302,
        "transcript": "Tau͡ga-ll' unuaquani imkucirlua, tupagtua perriteqalliniluteng, dry up-aqalliniluteng.",
        "translation": "Then the next morning, you know, I woke up and they had become clean, had dried up."
    },
    "131": {
        "startTime": 793.312,
        "endTime": 802.234,
        "transcript": "Dry up-aarngameng-llu maliggluku tauna kengelkelluku assiriinarluteng, kiitau͡gan' assiriut.",
        "translation": "And when they dried up, following that, they were getting better, until eventually they were gone."
    },
    "132": {
        "startTime": 802.712,
        "endTime": 806.99,
        "transcript": "Kinguakun-llu tayima pinqigtevkenii tau͡gaten.",
        "translation": "And after that, I never went through that again."
    },
    "133": {
        "startTime": 807.005,
        "endTime": 809.638,
        "transcript": "Caulriit ima tam' tamakut Kass'atun?",
        "translation": "What are those in English again?"
    },
    "134": {
        "startTime": 811.142,
        "endTime": 815.553,
        "transcript": "Root, root...",
        "translation": "Root, root..."
    },
    "135": {
        "startTime": 815.555,
        "endTime": 820.444,
        "transcript": "Caulriit im' makut Kass'atun root?",
        "translation": "What are these roots in English again?"
    },
    "136": {
        "startTime": 820.453,
        "endTime": 826.108,
        "transcript": "Roseworts. Ii-i, rosewort-aulliniut maa-i.",
        "translation": "Roseworts. Yes, these are roseworts."
    },
    "137": {
        "startTime": 828.143,
        "endTime": 831.876,
        "transcript": "Makuneng-llu-qaa kuvyat pitulqait caqlaneng?",
        "translation": "Would they also use these rosewort roots for drift nets?"
    },
    "138": {
        "startTime": 831.884,
        "endTime": 834.196,
        "transcript": "Kuvyanun cali atutullruyugnarqait.",
        "translation": "They probably also used them for drift nets."
    },
    "139": {
        "startTime": 834.206,
        "endTime": 836.073,
        "transcript": "(Qang'a.) Allaugut-qaa?",
        "translation": "(No.) Are they different?"
    },
    "140": {
        "startTime": 836.083,
        "endTime": 838.561,
        "transcript": "(Allaraat imkut.) Allarraulliniut makut.",
        "translation": "(Those different ones.) These are different."
    },
    "141": {
        "startTime": 838.566,
        "endTime": 841.121,
        "transcript": "Tamakut anuqetuliaraugut.",
        "translation": "Those are yarrows."
    },
    "142": {
        "startTime": 841.131,
        "endTime": 842.508,
        "transcript": "Nuu.",
        "translation": "No."
    },
    "143": {
        "startTime": 843.539,
        "endTime": 846.561,
        "transcript": "Anuqetuliaraat... (Caqlaugut maa-i makut.)",
        "translation": "Yarrows... (These are rosewort roots.)"
    },
    "144": {
        "startTime": 846.57,
        "endTime": 847.993,
        "transcript": "Caqlau[gut].",
        "translation": "They're rosewort roots."
    },
    "145": {
        "startTime": 848.457,
        "endTime": 853.601,
        "transcript": "Anuqetuliaraat piit, aciit kankut...",
        "translation": "The yarrow roots below..."
    },
    "146": {
        "startTime": 853.848,
        "endTime": 855.87,
        "transcript": "Kuvyanun piktulqait.",
        "translation": "THey use them on drift nets."
    },
    "147": {
        "startTime": 855.879,
        "endTime": 864.224,
        "transcript": "Piluki kuvyanun piaqameng kuvyaq una neqcuriqertetuuq.",
        "translation": "When they use them on drift nets, this drift net starts catching a lot."
    },
    "148": {
        "startTime": 864.502,
        "endTime": 866.425,
        "transcript": "Tamaaken...",
        "translation": "From there..."
    },
    "149": {
        "startTime": 866.483,
        "endTime": 872.594,
        "transcript": "Vicks-atun ayuqluteng. Allat, allakat cali vicks-atun ayuqelriit.",
        "translation": "They're like Vicks. Others, other kidns are also like Vicks."
    },
    "150": {
        "startTime": 872.601,
        "endTime": 875.857,
        "transcript": "Anuqetu[liaraat] tamakuunritut. Tamakut...",
        "translation": "Yarrows are not those. Those..."
    },
    "151": {
        "startTime": 879.838,
        "endTime": 880.827,
        "transcript": "Tau͡ga-qaa?",
        "translation": "Ready?"
    },
    "152": {
        "startTime": 881.841,
        "endTime": 886.507,
        "transcript": "Tan'gurraulqa nallunritaqa.",
        "translation": "I know when I was a boy."
    },
    "153": {
        "startTime": 887.38,
        "endTime": 899.925,
        "transcript": "Yuurtellruunga, yuurtelqa cali maa-i nalluvkenaku, 1902.",
        "translation": "I was born, and I know when I was born, 1902."
    },
    "154": {
        "startTime": 900.855,
        "endTime": 906.077,
        "transcript": "Wa-tau͡ga-i-am al'rrakurlua 88.",
        "translation": "I am 88 years old."
    },
    "155": {
        "startTime": 906.839,
        "endTime": 911.628,
        "transcript": "Cali ukut nunat teggneqsagullua.",
        "translation": "I am also now the elder of this village."
    },
    "156": {
        "startTime": 911.798,
        "endTime": 916.698,
        "transcript": "Wa-tau͡ga-i civulerniriullua cali ayuqlua.",
        "translation": "Now, I have no more elders too."
    },
    "157": {
        "startTime": 917.211,
        "endTime": 923.822,
        "transcript": "Caliangqerrlua alcohol [?mission]-aani calilua.",
        "translation": "I work at the alochol [?mission]."
    },
    "158": {
        "startTime": 923.833,
        "endTime": 932.822,
        "transcript": "Makuneng tan'gu'rrneng umyugiqelrianeng-llu qanruquraaqluki.",
        "translation": "I speak to these boys and those with mental health problems."
    },
    "159": {
        "startTime": 933.11,
        "endTime": 942.932,
        "transcript": "Allaneng cali pivkenaku wii eliskengameng tamaaken qanruyutellemneng tau͡ga qanerturautaqluki.",
        "translation": "Also, I always speak to them about the traditional wisdom I learned back then, and nothing else."
    },
    "160": {
        "startTime": 943.17,
        "endTime": 945.892,
        "transcript": "Tau͡ga assiriaqluteng tau͡ga.",
        "translation": "They get better."
    },
    "161": {
        "startTime": 945.906,
        "endTime": 956.895,
        "transcript": "Tamakut-llu umyugameggneng, waten-llu ellmeggneng pinaluteng umyugarturluteng piyaaqellrung'e'rmeng",
        "translation": "And even thought they had mental health problems, and they had thought of committing suicide"
    },
    "162": {
        "startTime": 956.905,
        "endTime": 964.916,
        "transcript": "Cillangarrluteng tau͡ga tamakuneng caskulirlua qanerturaraqama.",
        "translation": "They come to a realization when I have those as my speaking tools."
    },
    "163": {
        "startTime": 965.182,
        "endTime": 974.149,
        "transcript": "Wanigg' elpengellruunga qanrutescirlua, cat-gga tamalkuita qanrutestekluki.",
        "translation": "In my first memories, I had instructors, and they instructed about everything."
    },
    "164": {
        "startTime": 974.437,
        "endTime": 979.937,
        "transcript": "Aparrlugaanka, angagglugaanka tamaa-i tamakut.",
        "translation": "Those were my grandfathers, great-uncles, and maternal uncles."
    },
    "165": {
        "startTime": 979.95,
        "endTime": 986.25,
        "transcript": "Waten carraulua mik'nii aatama-llu ayuquciagua",
        "translation": "When I was very little child, my father also instructed me"
    },
    "166": {
        "startTime": 986.258,
        "endTime": 991.07,
        "transcript": "Tau͡gaam murilkeluaqerpegnaku atairutellruunga.",
        "translation": "But I lost my father without being able to fully observe him."
    },
    "167": {
        "startTime": 991.25,
        "endTime": 998.427,
        "transcript": "Aanama tau͡gaam elliin anglicaaralqaanga.",
        "translation": "However, my mother raised me."
    },
    "168": {
        "startTime": 998.822,
        "endTime": 1006.866,
        "transcript": "Tau͡ga tau͡gaten aanaka cali tauna naklektullruluku tangerrluku tau͡ga.",
        "translation": "I also used to pity that mother of mine like that, looking at her [situation]."
    },
    "169": {
        "startTime": 1007.427,
        "endTime": 1017.438,
        "transcript": "Tangerrlua tau͡ga nallumni tangvaagallininauraanga, qaillun-kiq umyugarteqluni. Piaqa maaggun aluvililuni.",
        "translation": "Without my knowledge, she looked at me, I wonder what she was thinking. I looked at her and she had tears streaming down here."
    },
    "170": {
        "startTime": 1017.451,
        "endTime": 1021.851,
        "transcript": "Naklegyugluni-gga tau͡ga nallunaituq pillra.",
        "translation": "It's clear that she felt pity."
    },
    "171": {
        "startTime": 1023.146,
        "endTime": 1036.146,
        "transcript": "Tau͡gaam maa-i alarquutet-gga tamakut tan'gurraullemteńi elpengelqa tamana waten civugngaluni pinarqenrituq.",
        "translation": "But the instructions when I had become aware as a boy should not be ignored."
    },
    "172": {
        "startTime": 1036.438,
        "endTime": 1045.071,
        "transcript": "Iliini anrutamineng-llu makuneng lavkaaneng piitellratni",
        "translation": "And sometimes, their stomachs, when they didn't have stores"
    },
    "173": {
        "startTime": 1045.083,
        "endTime": 1048.527,
        "transcript": "Unangkengameggneng tau͡gaam maaken piaqata",
        "translation": "When they only [ate] what they got from this [land]"
    },
    "174": {
        "startTime": 1048.535,
        "endTime": 1055.702,
        "transcript": "Iliini-llu anrutaq-gga kanavirtutekluku.",
        "translation": "Sometimes, they become downtrodden from their [empty] stomachs."
    },
    "175": {
        "startTime": 1055.714,
        "endTime": 1065.614,
        "transcript": "Cali caitellemteńeng, aturaitellemteńeng tamakuneng kanavirucirluta pitullruukut civugngavkenata.",
        "translation": "We would also be downtrodden because we had nothing, had no clothes, and did not ignore things."
    },
    "176": {
        "startTime": 1066.257,
        "endTime": 1077.212,
        "transcript": "Tamakut yullret angullrenka unangkengameggneng tau͡gaam maaken cuverkengameggneng, lavkaaneng pivkenateng",
        "translation": "Those people I was born in time to see, only had what they had obtained [?worked hard] for, not from stores"
    },
    "177": {
        "startTime": 1077.228,
        "endTime": 1082.461,
        "transcript": "Tamakuneng tau͡ga neq'lirluteng pitullruut.",
        "translation": "That was the food that they had."
    },
    "178": {
        "startTime": 1082.652,
        "endTime": 1088.519,
        "transcript": "Cali temait kayullruuq. Nallunritanka.",
        "translation": "Their bodies were also strong. I know them."
    },
    "179": {
        "startTime": 1088.525,
        "endTime": 1098.17,
        "transcript": "Makut ping'e'rmeng ak'allauluteng tangenge'rmeng pillret waten tau͡ga kayugluteng pillruluteng.",
        "translation": "They these people looked old, they were strong like this."
    },
    "180": {
        "startTime": 1098.318,
        "endTime": 1105.052,
        "transcript": "Cali tamakut elpenga'artellrenka tangellrenka yuut assillruut.",
        "translation": "Those people I saw in my first memories were also good."
    },
    "181": {
        "startTime": 1105.058,
        "endTime": 1107.236,
        "transcript": "Naklegtarluteng.",
        "translation": "They were compassionate."
    },
    "182": {
        "startTime": 1107.249,
        "endTime": 1113.689,
        "transcript": "Qanruyutai cali assirluteng tau͡ga tau͡gaten ayuqluteng.",
        "translation": "And their traditional wisdom, they were good like [what the wisdom instructed]."
    },
    "183": {
        "startTime": 1113.699,
        "endTime": 1119.899,
        "transcript": "Qanruyutai tau͡ga tau͡gaten ayuqluteng pillruluteng.",
        "translation": "They were in accrodance with their traditional wisdom."
    },
    "184": {
        "startTime": 1121.193,
        "endTime": 1132.549,
        "transcript": "Qanruquratulqaatnga tamakut pistekama uyviisqetevkenii waten pisqevkenii.",
        "translation": "Those whose responsibility I was always used to tell me not to act foolish."
    },
    "185": {
        "startTime": 1132.564,
        "endTime": 1140.019,
        "transcript": "Akuyrartellriit-llu makut ilagarluki pitullruunga.",
        "translation": "I also used to join those who were mischievous."
    },
    "186": {
        "startTime": 1140.03,
        "endTime": 1151.464,
        "transcript": "Tau͡ga-gguq tamaa-i tamakut-gga akuyrarulluteng, akuyrarrluteng pilriit cameng-gga unangnarqevkenateng.",
        "translation": "They said that those who are mischievous do not obtain anything."
    },
    "187": {
        "startTime": 1151.473,
        "endTime": 1162.151,
        "transcript": "Tau͡gaam una umyugartuareluni, qaillun-gga picirkani tamana-gga piureluku pilria-gga",
        "translation": "However, the one who is mindful, the one who always does what he needs to do"
    },
    "188": {
        "startTime": 1162.162,
        "endTime": 1167.806,
        "transcript": "Elluarrluni, assirluni-gga eglertetullruuq.",
        "translation": "He would go through life right and well."
    },
    "189": {
        "startTime": 1168.891,
        "endTime": 1172.835,
        "transcript": "Tau͡ga tau͡gaten ayuqucirput ayuqellruuq.",
        "translation": "That was what we were like."
    },
    "190": {
        "startTime": 1172.849,
        "endTime": 1179.671,
        "transcript": "Maa-i, maa-i-gga ayuqucirput pillruuq qutegnganarqellrunrituq.",
        "translation": "What we were like was nothing to boast about."
    },
    "191": {
        "startTime": 1179.677,
        "endTime": 1183.911,
        "transcript": "Tau͡ga kanavirtaqluni tau͡ga pitullruluni.",
        "translation": "It would make us despondent."
    },
    "192": {
        "startTime": 1184.19,
        "endTime": 1194.346,
        "transcript": "Cali makuneng Kass'allarneng lumber-aneng-llu makuneng, [?]-aq-llu tamaani piluku",
        "translation": "And these Western things back then, the lumber and these [?]"
    },
    "193": {
        "startTime": 1194.364,
        "endTime": 1198.941,
        "transcript": "Tamakuneng tau͡ga uquneng muragirluteng pitullruut.",
        "translation": "They would use that oil for fuel."
    },
    "194": {
        "startTime": 1205.209,
        "endTime": 1208.32,
        "transcript": "(Taqeqataquvet waten elliurciqamken.) Ii-i.",
        "translation": "(When you're almost done, I will wave to you like this.) Okay."
    },
    "195": {
        "startTime": 1208.851,
        "endTime": 1212.395,
        "transcript": "Tua-i-q' ayagnirtuq? You start?",
        "translation": "Has it started? You start?"
    },
    "196": {
        "startTime": 1212.664,
        "endTime": 1213.841,
        "transcript": "Yeah, go ahead.",
        "translation": "Yeah, go ahead."
    },
    "197": {
        "startTime": 1213.85,
        "endTime": 1220.228,
        "transcript": "Una-gguq wanigga wangkuta yungcautvut rosewort-aq.",
        "translation": "This is our medicine, rosewort."
    },
    "198": {
        "startTime": 1222.244,
        "endTime": 1225.222,
        "transcript": "Yugtun atengqerrluni caqlaq.",
        "translation": "In Yup'ik, it's called caqlaq."
    },
    "199": {
        "startTime": 1225.242,
        "endTime": 1228.031,
        "transcript": "Igyariqaqamta yungacuteput.",
        "translation": "It's our medicine when we have sore throats."
    },
    "200": {
        "startTime": 1228.035,
        "endTime": 1230.913,
        "transcript": "Wanigg' kepqataqa, kepluku.",
        "translation": "I'm going to cut it."
    },
    "201": {
        "startTime": 1232.24,
        "endTime": 1233.84,
        "transcript": "Aling.",
        "translation": "My goodness."
    },
    "202": {
        "startTime": 1234.804,
        "endTime": 1239.627,
        "transcript": "Kepluku wanigg, iliineng kepluku tamualua.",
        "translation": "I'm going to cut off a part of it and chew it."
    },
    "203": {
        "startTime": 1239.634,
        "endTime": 1245.023,
        "transcript": "Yungcautellrit maa-i makut akaurtellratni yungcautaitellratni.",
        "translation": "This was their medicine a long time ago when they didn't have [any other] medicine."
    },
    "204": {
        "startTime": 1255.413,
        "endTime": 1265.947,
        "transcript": "Maa-i makut igyariq'qapiarallemni-ll' icivaq cayaaqlua, yungcartet kapu'uryaaqlua taqlua, clinic-aryaaqlua. Kapuryaaqlua.",
        "translation": "When I had a very sore throat recently, the did things, the doctors gave me shots all over and I went to the clinic. They gave me shots."
    },
    "205": {
        "startTime": 1265.963,
        "endTime": 1270.718,
        "transcript": "Makut-am teguqerluki nerlua.",
        "translation": "I took these and ate."
    },
    "206": {
        "startTime": 1270.726,
        "endTime": 1275.859,
        "transcript": "Tau͡ga-ll' nerlua maaten unuaquani piaqa igyaqeriqelqa tayim' tamallinilria.",
        "translation": "ThenI ate and I found the next morning that my sore throat was gone."
    },
    "207": {
        "startTime": 1276.267,
        "endTime": 1279.989,
        "transcript": "Akaurtellrani tau͡gaam makut maa-i yungcautellrit.",
        "translation": "But a long time ago, this was their medicine."
    },
    "208": {
        "startTime": 1280.192,
        "endTime": 1283.936,
        "transcript": "Au͡gna pitangqertuq, pau͡gna-llu.",
        "translation": "There's some over there, and inland."
    },
    "209": {
        "startTime": 1284.494,
        "endTime": 1288.605,
        "transcript": "[?Nuliagat-gguq nulag]aqameng tau͡ga amlletuut amlleq.",
        "translation": "[?They say that when ?] there are a lot of them."
    },
    "210": {
        "startTime": 1288.613,
        "endTime": 1294.713,
        "transcript": "Maa-i-ll' quyurciluteng I got one whole, jar-aq imirluku.",
        "translation": "And altogether now, I got one whole full jar."
    },
    "211": {
        "startTime": 1295.18,
        "endTime": 1299.847,
        "transcript": "Qessakengraaki-llu alikengraaki panima makucit",
        "translation": "Though my daughter refuses and is scared of these"
    },
    "212": {
        "startTime": 1299.865,
        "endTime": 1312.653,
        "transcript": "\"Uyviipakar elpeni. Grandma-rpet-ggem pitulqaaten igyariqaqavet makuneng neresqelluten, tamualiqureluten-ll' nerqeńauraaten callarciaqan.\"",
        "translation": "\"You're so foolish. Wouldn't your grandmother tell you to eat these when you had a sore throat, and would chew them and feed them to you when you had sores?\""
    },
    "213": {
        "startTime": 1313.218,
        "endTime": 1317.196,
        "transcript": "Akaurtellrani tau͡gaten tau͡ga pitullruukut.",
        "translation": "We used to do that a long time ago."
    },
    "214": {
        "startTime": 1317.204,
        "endTime": 1324.148,
        "transcript": "Imkut-llu caiggluut cal' tamaa-i tamakut mecuitneng.",
        "translation": "And those things, wormwood, their juices too."
    },
    "215": {
        "startTime": 1324.294,
        "endTime": 1328.616,
        "transcript": "Al'rragni-llu not this summer",
        "translation": "And last year, not this summer"
    },
    "216": {
        "startTime": 1328.775,
        "endTime": 1336.741,
        "transcript": "Ingna last baby-qa, last baby-qa piipimneng tuqlutuaqa Peter-aq last baby-qngamku, kenekngamku cakneq.",
        "translation": "My last baby over there, I call my last baby my baby, because Peter is my last baby, because I love him so much."
    },
    "217": {
        "startTime": 1336.891,
        "endTime": 1342.157,
        "transcript": "Puverpakapiarluni. Clinic-aryaaqluni clinic-am caqerpegnaku.",
        "translation": "He was very swollen. He went to the clinic, and the clinic didn't do anything to him."
    }
};